import Constants from '../utils/Constants';
import ServiceBase from './ServiceBase';
import CompletionLockerNote from '../model/CompletionLockerNote';

const LOCKERNOTES_URL = Constants.ServiceAPI.inventoryUrl + 'record/lockernotes/';

export default class CompletionRecordService extends ServiceBase {

  /**
   * 
   * @param {int} id 
   * @param {int} containerId
   * @returns 
   */  
  getCompletionLockerNoteListing = (id, containerId) => {
    let params = [];
    params.push(Constants.Http.Param.Id + "=" + id);
    params.push(Constants.Http.Param.ContainerId + "=" + containerId);

    let url = this.getServiceUrl(LOCKERNOTES_URL + "?" + params.join("&") );

    let packet = this.buildRequestPacket(Constants.Http.Method.GET);

    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
      let convertedRecords = [];
      json.map(record => convertedRecords.push(new CompletionLockerNote(record)) );

      return convertedRecords;
    });
  }
  
  /**
   * 
   * @param {CompletionLockerNote} completionRecord 
   * @returns 
   */
  createNewCompletionLockerNote = (completionLockerNote) => {
    let url = this.getServiceUrl(LOCKERNOTES_URL);
    let packet = this.buildRequestPacket(Constants.Http.Method.POST, completionLockerNote);

    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
      return new CompletionLockerNote(json);
    });
  }

  /**
   * 
   * @param {CompletionLockerNote} completionRecord 
   */
  deleteExistingCompletionLockerNote = (completionLockerNote) => {
    let url = this.getServiceUrl(LOCKERNOTES_URL);
    let packet = this.buildRequestPacket(Constants.Http.Method.DELETE, completionLockerNote);

    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
      return json;
    });
  }

}